import { CourseRole } from '../types';

export interface CourseListItem {
  courseId: MongoId;
  code: string;
  title: string;
  role: CourseRole;
  startDate: UnixTime;
  endDate: UnixTime;
  /** -1 means course has no future classes */
  nextLecture: UnixTime;
  timezone: string;
}

export enum CourseType {
  /** The course is integrated with an LMS like BlackBoard, Canvas etc */
  SYNCED = 'synced',
  PLATFORM = 'platform',
  PLATFORM2 = 'platform2',
}

export enum EnrollmentBy {
  /** In these type of courses, a join-code is generated which can be used to enroll in a course  */
  CODE = 'enrolmentCode',
  /** Every student is invited using their emails, an invitation link is sent to their emails */
  INVITATION = 'enrolmentInvite',
}

export interface Course {
  id: MongoId;
  code: string;
  title: string;
  canProxy: boolean;
  isPro: boolean;
  courseType: CourseType;
  enrollmentType: EnrollmentBy;
  /** empty string when enrollmentType is EnrollmentBy.INVITATION */
  joinCode: string;
}
